/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationPercentage extends models.BillingRuleAllocation {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationPercentage");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationPercentage.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationPercentage>): BillingRuleAllocationPercentage {
        let obj = Object.assign(new BillingRuleAllocationPercentage(), model);
        BillingRuleAllocationPercentage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationPercentage>): BillingRuleAllocationPercentage {
        if (!model) return null;
        return BillingRuleAllocationPercentage.newInstance(<BillingRuleAllocationPercentage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationPercentage) {
        if (!obj) return;

        models.BillingRuleAllocationPercentage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationPercentage): boolean {
        if (models.BillingRuleAllocation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationPercentage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.targets) {
            for (let val of this.targets) {
                models.AllocationPercentageTarget.fixupPrototype(val);
            }
        }
    }

    /**
     * List of targets to allocate the cost to
     */
    targets: Array<models.AllocationPercentageTarget>;

}
